import { Phone, Mail, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 items-start">
          <div className="text-center md:text-left">
            <h3 className="text-2xl font-bold text-white mb-4">Tumble Gym</h3>
            <p className="text-gray-300 max-w-md mx-auto md:mx-0 text-justify">
              Welcome to Tumble Gym. We have got gymnastics and movement education 
              that will make your child’s heart soar. We take pride in delivering 
              age appropriate lessons that spark pure joy in every little one’s life.
            </p>
          </div>
          <div className="space-y-4 text-gray-300">
            <h4 className="text-lg font-semibold text-white mb-4">Contact Us</h4>
            <div className="flex items-center gap-3">
              <Phone className="w-5 h-5" />
              <a
                href="tel:+917019271281"
                className="hover:text-white transition"
              >
                +91 7019271281
              </a>
            </div>
            <div className="flex items-center gap-3">
              <Mail className="w-5 h-5" />
              <a
                href="mailto:info@tumblegym.in"
                className="hover:text-white transition"
              >
                info@tumblegym.in
              </a>
            </div>
            <div className="flex items-center gap-3">
              <MapPin className="w-10 h-15" />
              <a
                href="https://www.google.com/maps?q=5,+Indradhanush,+Hennur+Bagalur+Main+Road,+Kothanur,+Bengaluru+–+560077"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition"
              >
                5, Indradhanush, Hennur Bagalur Main Road, Kothanur, Bengaluru – 560077
              </a>
            </div>
          </div>
          <div className="space-y-4 text-gray-300">
            <h4 className="text-lg font-semibold text-white mb-4">Quick Links</h4>
            <div className="flex flex-col gap-3">
              <a
                href="/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition"
              >
                Privacy Policy
              </a>
              <a
                href="/terms"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition"
              >
                Terms & Conditions
              </a>
            </div>
          </div>
        </div>
        <div className="mt-8 text-center text-gray-200 text-sm">
          <p>
            Developed by <a href="https://thriveboost.in" className="text-white hover:text-primary">Thrive Boost</a>
          </p>
        </div>
      </div>
    </footer>
  );
};
